
// Define our floor structure
export const floors = [
  {
    id: 1,
    name: 'Ground Floor',
    loads: ['1', '3'] // IDs of loads on this floor
  },
  {
    id: 2,
    name: 'First Floor',
    loads: ['2', '5', '6', '7'] // IDs of loads on this floor
  },
  {
    id: 3,
    name: 'Second Floor',
    loads: ['4', '8', '9'] // IDs of loads on this floor
  }
];
